import { render } from "./ResetPassModal.vue?vue&type=template&id=17730b16"
import script from "./ResetPassModal.vue?vue&type=script&lang=js"
export * from "./ResetPassModal.vue?vue&type=script&lang=js"

import exportComponent from "/app/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__